import React, { forwardRef, useImperativeHandle } from 'react'
import { createPortal } from 'react-dom'
import classNames from 'classnames'

const Modal = forwardRef((props, ref) => {

  const [isOpen, setOpen] = React.useState(false)
  const [isClosing, setIsClosing] = React.useState(false)
  const [additionalClasses, setAdditionalClasses] = React.useState({})

  useImperativeHandle(ref, () => ({
    open () {
      setOpen(true)
    },
    close () {
      handleClose()
    },
    addClass(className) {
      setAdditionalClasses({
        ...additionalClasses,
        [className]: true,
      })
    },
    removeClass(className) {
      const newClasses = additionalClasses

      delete newClasses[className]

      setAdditionalClasses(newClasses)
    },
  }))

  const handleClose = () => {
    setIsClosing(true)
  }

  React.useEffect(() => {
      const closeTimer = setTimeout(() => {
        setOpen(false)
        setIsClosing(false)

        if (typeof props.onCloseCallback === 'function') {
          props.onCloseCallback()
        }
      }, 500)

      return () => clearTimeout(closeTimer)
    }, [isClosing])

  if (isOpen === false) {
    return null
  }

  return createPortal((
    <div className={classNames({
      'signup-modal': true,
      'signup-modal--close': isClosing,
      ...additionalClasses,
    })}>
      <div className="signup-modal__content">
        <div className="signup-modal__close" onClick={handleClose}></div>
        <div className="signup-modal__content-inner">
          {props.children}
        </div>
      </div>
      <div className="signup-modal__overlay" onClick={handleClose}></div>
    </div>
  ), document.getElementById('modal-container'))
})

export default Modal